/**
 * LogsService
 * Service for application logging
 * Route: api/logs
 */
import { BaseService } from '../base/BaseService';
export class LogsService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? LogsService.DEFAULT_SERVICE_PATH,
            basePath: LogsService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async getLogs(params) {
        const endpoint = this.getEndpoint('', '');
        const queryParams = {};
        if (params?.logLevel)
            queryParams.logLevel = params.logLevel;
        if (params?.serviceName)
            queryParams.serviceName = params.serviceName;
        if (params?.startDate)
            queryParams.startDate = params.startDate.toISOString();
        if (params?.endDate)
            queryParams.endDate = params.endDate.toISOString();
        if (params?.skip !== undefined)
            queryParams.skip = params.skip.toString();
        if (params?.take !== undefined)
            queryParams.take = params.take.toString();
        const url = this.buildUrlWithParams(endpoint, queryParams);
        const response = await this.http.get(url);
        return response.data ?? [];
    }
    async getLog(id) {
        const endpoint = this.getEndpoint('by-id', `${id}`);
        const url = this.buildUrl(endpoint);
        const response = await this.http.get(url);
        return response.data ?? null;
    }
    async getRecentLogs(count = 50, serviceName) {
        const endpoint = this.getEndpoint('recent', 'recent');
        const queryParams = { count: count.toString() };
        if (serviceName)
            queryParams.serviceName = serviceName;
        const url = this.buildUrlWithParams(endpoint, queryParams);
        const response = await this.http.get(url);
        return response.data ?? [];
    }
    async getErrorLogs(count = 100, serviceName) {
        const endpoint = this.getEndpoint('errors', 'errors');
        const queryParams = { count: count.toString() };
        if (serviceName)
            queryParams.serviceName = serviceName;
        const url = this.buildUrlWithParams(endpoint, queryParams);
        const response = await this.http.get(url);
        return response.data ?? [];
    }
    async getLogSummary(serviceName) {
        const endpoint = this.getEndpoint('summary', 'summary');
        const queryParams = {};
        if (serviceName)
            queryParams.serviceName = serviceName;
        const url = this.buildUrlWithParams(endpoint, queryParams);
        const response = await this.http.get(url);
        return response.data ?? null;
    }
    async getLogsByCorrelation(correlationId) {
        const endpoint = this.getEndpoint('by-correlation', `by-correlation/${correlationId}`);
        const url = this.buildUrl(endpoint);
        const response = await this.http.get(url);
        return response.data ?? [];
    }
    async getServices() {
        const endpoint = this.getEndpoint('services', 'services');
        const url = this.buildUrl(endpoint);
        const response = await this.http.get(url);
        return response.data ?? [];
    }
}
LogsService.DEFAULT_SERVICE_PATH = 'system';
LogsService.BASE_PATH = 'api/logs';
//# sourceMappingURL=LogsService.js.map